
export type TranslationRecord = {
  en: string;
  fr: string;
};

export const translations: Record<string, TranslationRecord> = {
  // Navigation
  'nav.home': { en: 'Home', fr: 'Accueil' },
  'nav.products': { en: 'Products', fr: 'Produits' },
  'nav.solutions': { en: 'Solutions', fr: 'Solutions' },
  'nav.pricing': { en: 'Pricing', fr: 'Tarification' },
  'nav.about': { en: 'About', fr: 'À propos' },
  'nav.consulting': { en: 'Consulting', fr: 'Consultation' },
  'nav.blog': { en: 'Blog', fr: 'Blog' },
  'nav.contact': { en: 'Contact', fr: 'Contact' },
  
  // Hero Section
  'hero.title': { 
    en: 'AI-Powered Tools for a Smarter Future', 
    fr: 'Des outils propulsés par l\'IA pour un avenir plus intelligent' 
  },
  'hero.subtitle': { 
    en: 'Empowering businesses with innovative AI solutions that drive growth and efficiency.', 
    fr: 'Autonomiser les entreprises avec des solutions d\'IA innovantes qui stimulent la croissance et l\'efficacité.' 
  },
  'hero.description': {
    en: 'Attaboy Intelligence Inc. develops and provides artificial intelligence solutions, including language models (LLMs), autonomous agents, Results-as-a-Service (RaaS), and intelligent APIs. The company also offers consulting services in project management and AI integration to optimize efficiency and reduce business costs. We also offer solutions to individuals through a subscription model.',
    fr: 'Attaboy Intelligence Inc. développe et fournit des solutions d\'intelligence artificielle, notamment des modèles de langage (LLMs), des agents autonomes, des Résultats-en-tant-que-Service (RaaS) et des API intelligentes. La société propose également des services de conseil en gestion de projet et en intégration d\'IA pour optimiser l\'efficacité et réduire les coûts d\'entreprise. Nous proposons également des solutions aux particuliers via un modèle d\'abonnement.'
  },
  'hero.cta.explore': { en: 'Explore Products', fr: 'Explorer les Produits' },
  'hero.cta.demo': { en: 'Book a Demo', fr: 'Réserver une Démo' },
  
  // Trust Indicators
  'trust.innovation': { en: 'Innovation', fr: 'Innovation' },
  'trust.simplicity': { en: 'Simplicity', fr: 'Simplicité' },
  'trust.trust': { en: 'Trust', fr: 'Confiance' },
  
  // Products Section
  'products.title': { en: 'Our AI-Powered Products', fr: 'Nos Produits Alimentés par l\'IA' },
  'products.subtitle': { 
    en: 'Cutting-edge tools designed to transform your business operations', 
    fr: 'Des outils de pointe conçus pour transformer les opérations de votre entreprise' 
  },
  'products.cta': { en: 'Learn More', fr: 'En savoir plus' },
  
  // Product cards
  'product.dailytools.title': { en: 'Daily Life Tools', fr: 'Outils Quotidiens' },
  'product.dailytools.desc': { 
    en: 'Simplify your daily routine with practical tools designed to make life easier and more efficient.', 
    fr: 'Simplifiez votre routine quotidienne avec des outils pratiques conçus pour rendre la vie plus facile et plus efficace.' 
  },
  
  'product.analytics.title': { en: 'AI Analytics Suite', fr: 'Suite d\'Analyse IA' },
  'product.analytics.desc': { 
    en: 'Transform raw data into actionable insights with our advanced analytics platform.', 
    fr: 'Transformez des données brutes en informations exploitables avec notre plateforme d\'analyse avancée.' 
  },
  
  'product.automation.title': { en: 'Workflow Automation', fr: 'Automatisation des Flux de Travail' },
  'product.automation.desc': { 
    en: 'Streamline your processes with intelligent automation tools designed for efficiency.', 
    fr: 'Rationalisez vos processus avec des outils d\'automatisation intelligents conçus pour l\'efficacité.' 
  },
  
  'product.assistant.title': { en: 'AI Assistant', fr: 'Assistant IA' },
  'product.assistant.desc': { 
    en: 'Your personal AI assistant for scheduling, research, and day-to-day tasks.', 
    fr: 'Votre assistant IA personnel pour la planification, la recherche et les tâches quotidiennes.' 
  },
  
  'product.integration.title': { en: 'API Integration', fr: 'Intégration API' },
  'product.integration.desc': { 
    en: 'Seamlessly connect our AI tools with your existing software ecosystem.', 
    fr: 'Connectez harmonieusement nos outils d\'IA à votre écosystème logiciel existant.' 
  },
  
  // Solutions Section
  'solutions.title': { en: 'Industry Solutions', fr: 'Solutions par Industrie' },
  'solutions.subtitle': { 
    en: 'Tailored AI solutions for various industries and use cases', 
    fr: 'Solutions d\'IA personnalisées pour diverses industries et cas d\'utilisation' 
  },
  
  'solutions.marketing.title': { en: 'Marketing', fr: 'Marketing' },
  'solutions.marketing.desc': { 
    en: 'Enhance campaign performance and customer targeting with AI-driven insights.', 
    fr: 'Améliorez la performance des campagnes et le ciblage des clients grâce aux informations basées sur l\'IA.' 
  },
  
  'solutions.finance.title': { en: 'Finance', fr: 'Finance' },
  'solutions.finance.desc': { 
    en: 'Optimize financial processes and gain predictive insights for better decision-making.', 
    fr: 'Optimisez les processus financiers et obtenez des informations prédictives pour une meilleure prise de décision.' 
  },
  
  'solutions.legal.title': { en: 'Legal', fr: 'Juridique' },
  'solutions.legal.desc': { 
    en: 'Streamline document review and contract analysis with our specialized AI tools.', 
    fr: 'Simplifiez la révision des documents et l\'analyse des contrats avec nos outils d\'IA spécialisés.' 
  },
  
  'solutions.smb.title': { en: 'Small Business', fr: 'Petites Entreprises' },
  'solutions.smb.desc': { 
    en: 'Affordable AI solutions scaled for small business needs and growth.', 
    fr: 'Solutions d\'IA abordables adaptées aux besoins et à la croissance des petites entreprises.' 
  },
  
  // About Section
  'about.title': { en: 'About Attaboy Intelligence', fr: 'À Propos d\'Attaboy Intelligence' },
  'about.mission': { 
    en: 'Making AI Radically Accessible', 
    fr: 'Rendre l\'IA Radicalement Accessible' 
  },
  'about.text': { 
    en: 'Founded with a vision to democratize artificial intelligence, Attaboy Intelligence creates tools that make advanced AI capabilities accessible to businesses of all sizes. Our Canadian-based team combines technical expertise with innovative thinking to develop solutions that solve real business challenges.', 
    fr: 'Fondé avec la vision de démocratiser l\'intelligence artificielle, Attaboy Intelligence crée des outils qui rendent les capacités avancées de l\'IA accessibles aux entreprises de toutes tailles. Notre équipe basée au Canada combine expertise technique et pensée innovante pour développer des solutions qui résolvent de véritables défis commerciaux.' 
  },
  'about.canadian': { 
    en: 'A Canadian Innovation from Québec', 
    fr: 'Une Innovation Canadienne et Québecoise' 
  },
  
  // New About Section translations
  'about.paragraph1': {
    en: "At Attaboy Intelligence, we believe artificial intelligence should be empowering—not intimidating. Founded with a bold vision to democratize AI, we design tools that bring the power of large language models, automation, and intelligent agents to businesses of all sizes.",
    fr: "Chez Attaboy Intelligence Artificielle, on croit que l\'intelligence artificielle devrait être un moteur d\'autonomie — pas une source de confusion. Fondée avec une vision ambitieuse de démocratiser l\'IA, notre entreprise conçoit des outils qui mettent la puissance des grands modèles de langage, de l\'automatisation et des agents intelligents à la portée des entreprises de toutes tailles."
  },
  'about.paragraph2': {
    en: "Whether you're a solo entrepreneur or an enterprise leader, our solutions are built to make your life easier, faster, and smarter.",
    fr: "Que vous soyez travailleur autonome ou dirigeant d\'une grande organisation, nos solutions sont faites pour rendre votre quotidien plus simple, plus rapide et plus intelligent."
  },
  'about.paragraph3': {
    en: "From our home base in Québec, Canada, we blend deep technical expertise with real-world understanding to solve everyday business problems—efficiently and affordably.",
    fr: "On combine une solide expertise technique à une compréhension concrète du terrain pour résoudre les défis d\'affaires quotidiens — de façon efficace et abordable."
  },
  'about.what_sets_us_apart': {
    en: "What sets us apart:",
    fr: "Ce qui nous distingue :"
  },
  'about.feature1': {
    en: "Practical innovation grounded in business needs",
    fr: "Une innovation pratique, ancrée dans les besoins d\'affaires réels"
  },
  'about.feature2': {
    en: "Bilingual, inclusive AI for global and local markets",
    fr: "Une IA bilingue et inclusive, pensée pour les marchés locaux et mondiaux"
  },
  'about.feature3': {
    en: "Plug-and-play SaaS tools, APIs, and agentic automation",
    fr: "Des outils SaaS clés en main, des API et de l\'automatisation intelligente"
  },
  'about.feature4': {
    en: "Proudly Canadian, with a commitment to data ethics and accessibility",
    fr: "Fièrement canadiens, avec un engagement fort envers l\'éthique des données et l\'accessibilité"
  },
  'about.paragraph4': {
    en: "We're not just building tools—we're shaping the future of work, where AI is accessible, transparent, and truly useful.",
    fr: "On ne fait pas que bâtir des outils — on redéfinit le futur du travail, un avenir où l\'IA est accessible, transparente et réellement utile."
  },
  'about.paragraph5': {
    en: "Join us as we redefine what AI can do—for everyone.",
    fr: "Joignez-vous à nous pour repenser ce que l\'IA peut accomplir — pour tout le monde."
  },
  
  // Contact Section
  'contact.title': { en: 'Get in Touch', fr: 'Contactez-nous' },
  'contact.subtitle': { 
    en: 'Have questions? Want to book a demo? Our team is ready to help.', 
    fr: 'Vous avez des questions? Vous souhaitez réserver une démo? Notre équipe est prête à vous aider.' 
  },
  'contact.form.name': { en: 'Name', fr: 'Nom' },
  'contact.form.email': { en: 'Email', fr: 'Email' },
  'contact.form.message': { en: 'Message', fr: 'Message' },
  'contact.form.submit': { en: 'Send Message', fr: 'Envoyer le Message' },
  'contact.form.success': { en: 'Message sent successfully!', fr: 'Message envoyé avec succès!' },
  'contact.form.error': { en: 'Failed to send message', fr: 'Échec de l\'envoi du message' },
  
  // Footer
  'footer.rights': { 
    en: 'All rights reserved', 
    fr: 'Tous droits réservés' 
  },
  'footer.privacy': { en: 'Privacy Policy', fr: 'Politique de Confidentialité' },
  'footer.terms': { en: 'Terms of Service', fr: 'Conditions d\'Utilisation' },
};
